import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['calltouchable']

  checkCalltouch() {
    this.calltouchableTarget.value = window.Calltouch != undefined
  }
}
